import { type SortableEvent, type SortableOptions } from 'sortablejs';

function checkCommentNode(nodes: NodeList): void {
    if (!nodes || !nodes.length) {
        return;
    }

    const nodesLength = nodes.length;
    const commentNodeIdx = Number(
        Array.from(nodes).findIndex((node: ChildNode) => node.nodeType === Node.COMMENT_NODE)
    );

    if (commentNodeIdx === nodesLength - 1) {
        return;
    }

    nodes[commentNodeIdx].parentNode.insertBefore(nodes[nodesLength - 1], nodes[commentNodeIdx]);
}

export const sortableJsRootConfig: SortableOptions = {
    animation: 150,
    swapThreshold: 0.5,
    onEnd: (event: SortableEvent) => checkCommentNode(event.from.childNodes),
};
